// From ISO 4217 (06/12/2021)
const CURRENCIES_WITHOUT_DECIMALS = new Set([
    'CVE',
    'IDR',
    'ISK',
    'BIF',
    'CLP',
    'DJF',
    'GNF',
    'ISK',
    'JPY',
    'KMF',
    'KRW',
    'PYG',
    'RWF',
    'UGX',
    'UYI',
    'VND',
    'VUV',
    'XAF',
    'XOF',
    'XPF',
]);
const isCurrencyWithoutDecimals = (currencyCode) => CURRENCIES_WITHOUT_DECIMALS.has(currencyCode);
export default isCurrencyWithoutDecimals;
